<mat-card class="confirm-card">
  <mat-card-title data-at-dialog-title>
    <h2 class="header">
      {{ '+INSTALLATIONS.OPTIMIZATION_OVERLAY.HEADER' | translate }}
      <mat-icon class="close-icon" (click)="dialogRef.close()">close</mat-icon>
    </h2>
  </mat-card-title>
  <mat-card-content data-at-dialog-body>
    <div
      class="recommendation"
      *ngFor="
        let installation of viguideRecommendationsStore.installationsWithRecommendations$ | async
      "
    >
      <div class="image-wrapper">
        <img *ngIf="installation.image" class="image" [src]="installation.image" />
        <img *ngIf="!installation.image" class="image" src="/assets/img/devices/device_small.png" />
      </div>
      <div class="owner">
        <div>
          <span *ngIf="installation.marketingName">
            {{ installation.marketingName }}<span class="grey-text"> &#183; </span>
          </span>
          <span class="grey-text">{{ installation.id }}</span>
        </div>
        <span class="grey-text">{{ installation.ownerName }}, {{ installation.location }}</span>
      </div>
      <div class="recommendation__wrapper">
        <app-banner
          *ngFor="let recommendation of installation.recommendations"
          [linkInNewLine]="true"
          [linkForRouter]="['/installations/' + installation.id]"
          [queryParams]="{ gatewaySerial: installation.gatewaySerial }"
          (clickEvent)="dialogRef.close()"
          [linkLabel]="'+INSTALLATIONS.OPTIMIZATION_OVERLAY.GO_TO_SETTINGS' | translate"
          linkGtm="onGoToPage"
          linkGtmAction="Installation details"
          linkGtmCategory="Optimization overlay"
        >
          {{
            '+INSTALLATIONS.OPTIMIZATION_OVERLAY.RECOMMENDATION_' + recommendation.translationSlug
              | uppercase
              | translate: { hc: recommendation.hc }
          }}
        </app-banner>
      </div>
    </div>
  </mat-card-content>
</mat-card>
